export default "__VITE_ASSET__CuhBsOH3__"